import { Navigate, useNavigate } from "react-router-dom";
import { useAuthStore } from "../AuthStore/AuthStore";
import React from "react";

interface RequireAccessProps {
  allowedRoles?: number[];
  requiredPermissions?: string[];
  children: JSX.Element;
}

const RequireAccess = ({
  allowedRoles,
  requiredPermissions,
  children,
}:RequireAccessProps) => {
  const { currentuserroleList } = useAuthStore();
  const navigate  = useNavigate();
  const roleIds = (currentuserroleList ?? []).map((role: any) => role.Id) || [];

  const hasRole =
    allowedRoles?.some((roleId) => roleIds.includes(roleId)) ?? true;

    const hasPermission =
    requiredPermissions?.some((requiredPerm) =>
      (currentuserroleList ?? []).some((role: any) =>
        role.permissionsList?.some(
          (perm: any) => perm.SystemName == requiredPerm
        )
      )
    ) ?? true;
    console.log('haspermisison',hasPermission)

  const isAuthorized = hasRole && hasPermission;

  return isAuthorized ? children : <Navigate to="/access-denied" replace />;
};

export default RequireAccess;
